import { ChangeDetectionStrategy, Component } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { Router } from "@angular/router";

import { BackgroundOperationService } from "@app/core/background-operations/background-operation.service";
import { EBackgroundOperationStatus, IBackgroundOperation } from "@app/core/background-operations/background-operation.type";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "under-ui-background-operation-indicator",
  templateUrl: "./background-operation-indicator.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButtonModule, MatIconModule, TranslateModule],
  standalone: true,
})
export class BackgroundOperationIndicatorComponent {
  protected readonly operations = this.backgroundOperationService.operations;
  protected readonly statuses = EBackgroundOperationStatus;

  constructor(
    private readonly router: Router,
    private readonly backgroundOperationService: BackgroundOperationService,
  ) {}

  protected onOpen(operation: IBackgroundOperation): void {
    this.router.navigate([...operation.openRoute], { queryParams: operation.openQueryParams });

    if (operation.status !== EBackgroundOperationStatus.InProgress) {
      this.backgroundOperationService.dismiss(operation.id);
    }
  }
}
